/* eslint-disable max-len */
/* eslint-disable object-curly-newline */
/* eslint-disable no-console */
import React, { useState, MouseEvent } from "react";

import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";

import InfoIcon from "@mui/icons-material/InfoOutlined";
import { DialogState, setInformation, setInformationSetter } from "../../logic/hook/useDialogStateHelper";
import { StyledDialog } from "./Dialog";

export const InformationDialog = () => {
    const [informationState, setInformationState] = useState<DialogState>({ open: false });
    setInformationSetter(setInformationState);
    setInformation(informationState);

    const resolve = () => {
        if (informationState.resolve) {
            informationState.resolve(false);
        }
    };

    const onClickOK = () => {
        resolve();
        setInformationState({ open: false });
    };
    const onClose = (event: MouseEvent<HTMLInputElement>, reason: "backdropClick") => {
        // バックドロップクリック時に閉じるのを無効化
        if (reason === "backdropClick") {
            return;
        }
        onClickOK();
    };

    return (
        <>
            {informationState.open && informationState.message && (
                <StyledDialog open={informationState.open} onClose={onClose} fullWidth>
                    <DialogTitle component="div">
                        <Grid container direction="row" justifyContent="flex-start" alignItems="center" sx={{ width: "100%" }}>
                            <InfoIcon />
                            メッセージ
                        </Grid>
                    </DialogTitle>
                    <DialogContent dividers sx={{ maxHeight: "70vh" }}>
                        <DialogContentText
                            dangerouslySetInnerHTML={{
                                __html: informationState.message,
                            }}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={onClickOK} size="small">
                            OK
                        </Button>
                    </DialogActions>
                </StyledDialog>
            )}
        </>
    );
};
